// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__E82UA","addWidgetButton":"Header_addWidgetButton__uSri3","dashboardTabs":"Header_dashboardTabs___pJiU","active":"Header_active__lduga"};